import { ReactNode } from 'react';

import { Column } from '../Column/Column';
import { Row } from '../Row/Row';
import {
	SheetModalHeaderContainer,
	SheetModalHeaderDragIndicator,
	SheetModalHeaderIconContainer,
	SheetModalHeaderTitle,
} from './style';

export interface SheetModalHeaderProps {
	title?: string;
	prepend?: ReactNode;
}

export function SheetModalHeader({ title, prepend }: SheetModalHeaderProps) {
	return (
		<SheetModalHeaderContainer>
			<Column $gap={13}>
				<Row $hcenter={true}>
					<SheetModalHeaderDragIndicator />
				</Row>
				<Row $gap={10} $vcenter={true}>
					{prepend && <SheetModalHeaderIconContainer>{prepend}</SheetModalHeaderIconContainer>}
					{title && <SheetModalHeaderTitle>{title}</SheetModalHeaderTitle>}
				</Row>
			</Column>
		</SheetModalHeaderContainer>
	);
}
